import React from "react";
import AboutSection from "../components/AboutSection";
import WhyChoose from "../components/WhyChoose";
import Breadcrumb from "../components/Breadcrumb";
import { Helmet } from "react-helmet";

export default function About() {
  return (
    <>
        <Helmet>
        <title>About | Healthtech Solutions</title>

        <meta
          name="description"
          content="Learn about HealthTech Solutions Pvt Ltd, an AI-enabled IT and digital solutions company delivering web development, digital marketing, software, and IT consulting services globally."
        />

        <meta
          name="keywords"
          content="AI solutions company, digital marketing agency, SEO services, website development company, software development company, IT consulting services, AI technology solutions"
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://www.healthtechsl.com/about-us" />

        {/* Open Graph */}
        <meta property="og:title" content="About Healthtech Solutions" />
        <meta
          property="og:description"
          content="Learn about our AI powered digital services, software development expertise and technology solutions."
        />
        <meta
          property="og:image"
          content="https://www.healthtechsl.com/images/about-banner.jpg"
        />
        <meta property="og:url" content="https://www.healthtechsl.com/about-us" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Healthtech Solutions" />
        <meta
          name="twitter:description"
          content="Learn about our AI powered digital services, software development expertise and technology solutions."
        />
        <meta
          name="twitter:image"
          content="https://www.healthtechsl.com/images/about-banner.jpg"
        />

        {/* JSON-LD AboutPage */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "AboutPage",
              name: "About Healthtech Solutions",
              url: "https://www.healthtechsl.com/about-us",
              description:
                "Healthtech Solutions is an AI driven digital technology company offering IT, marketing and software services.",
            }),
          }}
        />

        {/* JSON-LD Organization */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              name: "Healthtech Solutions Pvt Ltd",
              url: "https://www.healthtechsl.com",
              logo: "https://www.healthtechsl.com/images/logo.png",
            }),
          }}
        />

        {/* JSON-LD FAQ (FIXED) */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "What is Healthtech Solutions?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Healthtech Solutions is an AI-powered digital and IT services company offering web development, SEO, software development, and consulting services.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Where is Healthtech Solutions located?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Healthtech Solutions operates globally and serves clients across multiple industries.",
                  },
                },
              ],
            }),
          }}
        />
      </Helmet>

      <Breadcrumb title="About Us" />
      <AboutSection />
      <WhyChoose />
    </>
  );
}
